import { useEffect, useState } from 'react';
import { BOOKED_COPY, BOOKED_MESSAGE, bookingRecentlyShown, isBookedKind, markBookingShown, type BookedKind } from '../lib/bookingConfirmation';
import { trackEvent } from '../lib/analytics';

/**
 * Confirmation shown at the top of the home page after a Cal.com booking
 * (`/?booked=walkthrough|15min|consulting`). Dismissable, announced politely,
 * and the parameter is stripped from the address bar so a refresh or a shared
 * link doesn't show it again. If the page is loaded inside the chat widget's
 * booking iframe, it tells the widget instead of showing a banner.
 */
export const BookingBanner = () => {
  const [kind, setKind] = useState<BookedKind | null>(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('booked')) return;
    const value = url.searchParams.get('booked');
    url.searchParams.delete('booked');
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
    if (!isBookedKind(value)) return;
    if (window.self !== window.top) {
      // Inside the widget's booking iframe: hand it to the chat.
      window.parent.postMessage({ type: BOOKED_MESSAGE, kind: value }, window.location.origin);
      return;
    }
    if (bookingRecentlyShown()) return;
    markBookingShown(value);
    setKind(value);
    trackEvent('booking_confirmed', { kind: value });
  }, []);

  if (!kind) return null;
  return (
    <div className="ht-booked" role="status">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.7 2.7L16 9.8" /></svg>
      <p>{BOOKED_COPY[kind]}</p>
      <button type="button" aria-label="Dismiss" onClick={() => setKind(null)}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>
  );
};
